var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.32757 2.32757C3.37231 1.28284 4.87171 0.833496 6.66683 0.833496H13.3335C15.1286 0.833496 16.628 1.28284 17.6728 2.32757C18.7175 3.37231 19.1668 4.87171 19.1668 6.66683V13.3335C19.1668 15.1286 18.7175 16.628 17.6728 17.6728C16.628 18.7175 15.1286 19.1668 13.3335 19.1668H2.50016C1.58159 19.1668 0.833496 18.4187 0.833496 17.5002V6.66683C0.833496 4.87171 1.28284 3.37231 2.32757 2.32757ZM3.50608 3.50608C2.88415 4.12802 2.50016 5.12862 2.50016 6.66683V17.5002H13.3335C14.8717 17.5002 15.8723 17.1162 16.4942 16.4942C17.1162 15.8723 17.5002 14.8717 17.5002 13.3335V6.66683C17.5002 5.12862 17.1162 4.12802 16.4942 3.50608C15.8723 2.88415 14.8717 2.50016 13.3335 2.50016H6.66683C5.12862 2.50016 4.12802 2.88415 3.50608 3.50608Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7.91683C5 7.45659 5.3731 7.0835 5.83333 7.0835H14.1667C14.6269 7.0835 15 7.45659 15 7.91683C15 8.37707 14.6269 8.75016 14.1667 8.75016H5.83333C5.3731 8.75016 5 8.37707 5 7.91683Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 12.0833C5 11.6231 5.3731 11.25 5.83333 11.25H11.6667C12.1269 11.25 12.5 11.6231 12.5 12.0833C12.5 12.5436 12.1269 12.9167 11.6667 12.9167H5.83333C5.3731 12.9167 5 12.5436 5 12.0833Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPost);
export default __webpack_public_path__ + "static/media/post.167a3c7f5eb8b5890f9663d253ca95ee.svg";
export { ForwardRef as ReactComponent };